import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS,
  SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS,
  FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS,
  LOADING_SAVE_MISCELLANEOUS_DOCUMENTS,
} = documentationActions;

function* saveMiscellaneousDocument(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SAVE_MISCELLANEOUS_DOCUMENTS });
    const response = yield call(templateService.saveMiscellaneousDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS, payload: error });
  }
}

function* saveMiscellaneousDocumentSaga() {
  yield takeEvery(REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS, saveMiscellaneousDocument);
}

export default saveMiscellaneousDocumentSaga;
